<script>
    export default {
        name: "BrandHero",
        data() {
            return {
                isAnimated: true,
            };
        },
        mounted() {
            setTimeout(() => {
                this.isAnimated = false;
            }, 500);
        },
    };
</script>

<template>
    <section class="brand-hero" :class="{ 'is-animated': isAnimated }">
        <div class="brand-hero__image">
            <picture>
                <source
                    media="(max-width: 991px)"
                    srcset="/static/xd-design/brand-history/brand-hero--mobile.jpg"
                />
                <img src="/static/xd-design/brand-history/brand-hero.jpg" alt="" />
            </picture>
        </div>

        <div class="brand-hero__text">
            <div class="brand-hero__title">
                <span class="desktop-hidden">История XD&nbsp;Design</span>
                <span class="brand-hero__title-scrolled mobile-hidden">
                    История XD&nbsp;Design История XD&nbsp;Design История XD&nbsp;Design
                    История XD&nbsp;Design История XD&nbsp;Design
                </span>
                <span class="brand-hero__title-scrolled mobile-hidden">
                    История XD&nbsp;Design История XD&nbsp;Design История XD&nbsp;Design
                    История XD&nbsp;Design История XD&nbsp;Design
                </span>
            </div>
            <div class="brand-hero__description">
                Нидерландский бренд завоевал сердца потребителей в 50+ странах мира.
                <span> Главный проект XD Design — серия противокражных рюкзаков Bobby </span>
            </div>
        </div>
    </section>
</template>

<style lang="scss">
    .brand-hero {
        position: relative;
        color: #fff;
        background-color: #000;
        overflow: hidden;
        &.is-animated {
            .brand-hero__image {
                opacity: 0;
                transform: translateX(50%);
            }
            .brand-hero__title {
                opacity: 0;
                transform: translateX(50%);
            }
            .brand-hero__description {
                opacity: 0;
                transform: translateX(-50%);
            }
        }
        @include bp($bp-desktop-sm) {
            display: flex;
            min-height: 469px;
        }
    }

    .brand-hero__image {
        position: relative;
        padding-bottom: 87.77%;
        transition: transform 0.7s cubic-bezier(0, 0, 0.13, 1),
            opacity 0.7s cubic-bezier(0, 0, 0.13, 1);
        img {
            @include center-absolute(0);
            width: 100%;
        }
        @include bp($bp-desktop-sm) {
            flex-shrink: 0;
            order: 1;
            width: 909px;
            height: 378px;
            padding-bottom: 0;
        }
    }

    .brand-hero__text {
        padding: 12px 0 60px 8.88%;
        @include bp($bp-desktop-sm) {
            padding: 175px 52px 0 calc((100vw - 1260px) / 2);
        }
    }

    .brand-hero__title {
        margin-bottom: 32px;
        font-size: 67px;
        font-weight: 100;
        line-height: 61px;
        text-transform: uppercase;
        transition: transform 1.2s cubic-bezier(0, 0, 0.13, 1) 0.2s,
            opacity 1.2s cubic-bezier(0, 0, 0.13, 1) 0.2s;
        @include bp($bp-desktop-sm) {
            position: absolute;
            z-index: 2;
            left: 0;
            bottom: 22px;
            display: flex;
            width: 2500px;
            font-size: 116px;
            line-height: 70px;
            white-space: nowrap;
            transition-duration: 4s, 2s;
            transition-delay: 0.4s;
        }
    }

    .brand-hero__title-scrolled {
        @include bp($bp-desktop-sm) {
            position: relative;
            left: 0;
            display: block;
            animation: scrolling-text 30s linear infinite;
        }
    }

    .brand-hero__description {
        font-size: 14px;
        font-weight: 300;
        line-height: 28px;
        transition: transform 0.7s cubic-bezier(0, 0, 0.13, 1) 0.3s,
            opacity 0.7s cubic-bezier(0, 0, 0.13, 1) 0.3s;
        span {
            display: block;
        }
        @include bp($bp-desktop-sm) {
            font-size: 18px;
            line-height: 30px;
            letter-spacing: 0.03em;
            span {
                display: inline;
            }
        }
    }

    @keyframes scrolling-text {
        0% {
            transform: translateX(0);
        }
        100% {
            transform: translateX(-100%);
        }
    }
</style>
